import { Box } from '@mui/system';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CheckIcon from '@mui/icons-material/Check';
import ButtonCustom from 'src/shared/components/buttons/ButtonCustom'
import { Grid } from "@mui/material"
import FormCreatePassword from "./components/FormCreatePassword"
import useSavePatient from '../hooks/useSavePatient';
import { errorsFormRegisterState, rulesPasswordState } from '../state/atoms';
import { useRecoilValue } from 'recoil';

const IndexCreatePassword = () => {
    const { handleClickSavePatient, handleBackStep, loading } = useSavePatient();
    const rulesPassword = useRecoilValue(rulesPasswordState);
    const { matchPassword } = useRecoilValue(errorsFormRegisterState);

    return (
        <div className='animate__animated animate__fadeIn'>
            <FormCreatePassword />
            <Grid container display={"flex"} justifyContent={"flex-end"} pt={2} spacing={2}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: '16px 0px 16px 0px'
                }}>
                    <ButtonCustom
                        disabled={matchPassword.length > 0 ? true : false}
                        style={{ marginRight: 15 }}
                        text="ANTERIOR"
                        color="secondary"
                        icon={<ArrowBackIosIcon />}
                        onClick={handleBackStep}
                    />
                    <ButtonCustom
                        loading={loading}
                        disabled={Object.values(rulesPassword).some(x => x === false) ? true : false}
                        text="CREAR CONTRASEÑA"
                        color="secondary"
                        icon={<CheckIcon />}
                        onClick={handleClickSavePatient}
                    />
                </Box>

            </Grid>
        </div>
    )
}

export default IndexCreatePassword
